import React from 'react';
import { useDispatch } from 'react-redux';

import {
  AthenaPracticeOptions,
  getAthenaDepartmentIdOptions,
  getAthenaDepartmentLabelById,
  getAthenaDepartmentLabelByValue,
  getAthenaDepartmentOptions,
  getAthenaDepartments,
  normalizeAthenaDepartments,
} from 'common-src/models/PatientIntegrationsAthena';

const getDefaultPracticeId = () => AthenaPracticeOptions[0]?.value ?? null;

const useAthenaDepartments = (practiceId = getDefaultPracticeId()) => {
  const dispatch = useDispatch();
  const [departments, setDepartments] = React.useState(() => normalizeAthenaDepartments([]));
  const normalizedPracticeId = practiceId || getDefaultPracticeId();

  React.useEffect(() => {
    if (!normalizedPracticeId) return undefined;

    let isMounted = true;
    dispatch(
      getAthenaDepartments(normalizedPracticeId, {
        successBlock: (response) => {
          if (!isMounted) return;
          setDepartments(normalizeAthenaDepartments(response));
        },
        errorBlock: () => {
          if (!isMounted) return;
          setDepartments(normalizeAthenaDepartments([]));
        },
      }),
    );

    return () => {
      isMounted = false;
    };
  }, [dispatch, normalizedPracticeId]);

  return React.useMemo(
    () => ({
      departments,
      departmentOptions: getAthenaDepartmentOptions(departments),
      departmentIdOptions: getAthenaDepartmentIdOptions(departments),
      departmentLabelById: getAthenaDepartmentLabelById(departments),
      departmentLabelByValue: getAthenaDepartmentLabelByValue(departments),
    }),
    [departments],
  );
};

export default useAthenaDepartments;
